module.exports = __webpack_public_path__ + "img/Barre_Actions_MercuComparative.82ef7248.png";